import { faRotateRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { ErrorTip } from './ErrorTip';
import { CollectionsViewModel } from '../collections.viewModel';
import * as styles from './DuplicationError.css';

export const DuplicationError = (p: Pick<CollectionsViewModel, 'dispatch'>) => {
  return (
    <ErrorTip
      title="Duplication failed"
      action={
        <Typography
          onClick={() => p.dispatch({ type: 'retryDuplication' })}
          className={styles.retryButton}
        >
          Retry
          <FontAwesomeIcon icon={faRotateRight} />
        </Typography>
      }
    >
      Something went wrong while duplicating the program. Please try again or
      contact support if the issue persists.
    </ErrorTip>
  );
};
